import styled from 'styled-components';

export const StyledLeadsTasks = styled.div`
  position: relative;
  display: flex;

  &.selection-mode {
    min-height: unset;
    height: 100%;
    flex-direction: column;
    overflow: hidden;

    .selection-content {
      display: flex;
      flex: 1;
      min-height: 0;
      overflow: hidden;
      align-items: flex-start;
    }

    .filter-column {
      display: flex;
      flex-direction: column;
      align-self: flex-start;
      height: fit-content;
      max-height: 100%;
      width: 220px;
      border-right: 1px solid #e6e7ec;
      overflow: hidden;

      @media (min-width: 1200px) {
        width: 260px;
      }

      @media (max-width: 768px) {
        display: none;
      }

      .head,
      .core-filer {
        flex-shrink: 0;
      }

      .filter-holder {
        flex: 0 1 auto;
        min-height: 0;
        height: fit-content;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
      }
    }

    .table-area {
      align-self: stretch;
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 0;
      position: relative;
      overflow: hidden;

      > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
      }

      .inner-wrap {
        height: 100% !important;
        max-height: 100%;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        min-height: 0;
        padding-bottom: 0;
      }

     

      .inner-wrap > div:not(.table-footer) {
        flex: 1;
        min-height: 0;
        height: auto !important;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 0;
        }
      }

      .inner-wrap > div:not(.table-footer) > div {
        height: auto !important;
        padding-bottom: 0 !important;
      }

      table {
        height: auto !important;

        th, td {
          padding: 8px 12px;
          font-size: 13px;
        }
      }

      .table-footer {
        position: static;
        width: 100%;
        right: auto;
        left: auto;
        background: var(--white);
        z-index: 1;
        flex-shrink: 0;
      }
    }

    .selection-footer {
      flex-shrink: 0;
    }
  }

  .filter-column {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-self: flex-start;
    width: 260px;
    height: fit-content;
    max-height: calc(100dvh - 50px);
    overflow: hidden;
    border-right: 1px solid #e6e7ec;
    transition: all 0.350s ease-in-out;
    
    @media (min-width: 1450px) {
      width: 300px;
    }

       .trial-banner-visible & {
            max-height: calc(100dvh - 92px);
            }

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .head {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      gap: 10px;
      padding: 14px 15px 10px;
      border-bottom: 1px solid #e6e7ec;
      background: #fdfdfd;

      @media (min-width: 1500px) {
        padding: 12px 15px 15px;
      }

      .subtitle {
        display: block;
        font-size: 12px;
        line-height: 15px;
        font-weight: 600;
        color: #7f8594;
      }

      .btn-filter {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: #f4f9fe;
      }

      input {
        @media (max-width: 1199px) {
          height: 33px;
        }
      }
    }

    .core-filer {
      flex-shrink: 0;
      width: 100%;
      padding: 5px 20px;
      font-size: 12px;
      line-height: 15px;
      font-weight: 600;
      border-bottom: 1px solid rgba(221, 221, 221, 0.5);
    }

    .filter-holder {
      flex: 0 1 auto;
      min-height: 0;
      height: fit-content;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
  }


  .table-area {
    flex-grow: 1;


    &.leads-module {
      min-width: 0;

      .inner-wrap {
        height: calc(100vh - 105px) !important;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        min-height: 0;
        transition: all 0.350s ease-in-out;
        
        @media (min-width: 1450px) {
        height: calc(100vh - 134px) !important;
        }
        .trial-banner-visible & {
          height: calc(100vh - 147px) !important;
          @media (min-width: 1450px) {
          height: calc(100vh - 170px) !important;
        }
        }
      }

      .leads-table-scroll {
        flex: 1;
        min-height: 0;
        overflow: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
      }

      table {
        width: 100%;
        table-layout: fixed;
      }

      th,
      td {
        overflow-wrap: anywhere;
        word-break: break-word;
        white-space: normal;
      }

      td:first-child .lead-td-col {
        width: 100%;
      }

      /* Laptop / desktop: pin the Name (first) and Action (last) columns
         while the middle columns scroll horizontally */
      @media (min-width: 992px) {
        table {
          min-width: 1020px;
        }

        th,
        td {
          width: 180px;
        }

        th:first-child,
        td:first-child {
          position: sticky;
          left: 0;
          z-index: 4;
          width: 210px;
          text-align: left;
          background: #fff;
          box-shadow: inset -6px 0 6px -6px rgba(0, 0, 0, 0.18);
        }

        thead th:first-child {
          z-index: 6;
          background: #fdfdfd;
        }

        th:last-child,
        td:last-child {
          position: sticky;
          right: 0;
          z-index: 4;
          width: 60px;
          background: #fff;
          box-shadow: inset 6px 0 6px -6px rgba(0, 0, 0, 0.18);
        }

        thead th:last-child {
          z-index: 6;
          background: #fdfdfd;
        }

        tbody tr.dropdown-open td:last-child {
          z-index: 8;
        }
      }

      /* On large screens everything fits, so disable horizontal scroll
         and the sticky-column shadows */
      @media (min-width: 1450px) {
        table {
          min-width: 100%;
        }

        th:first-child,
        td:first-child,
        th:last-child,
        td:last-child {
          box-shadow: none;
        }
      }
    }

    table {
      th,
      td {
        text-align: center;
      }

      thead {
        border-bottom: 1px solid #e6e7ec;
        background: rgba(253, 253, 253, 0.5);
        position: relative;
        z-index: 3;

        .th-label-box {
          position: relative;
          display: flex;
          align-items: center;
          gap: 8px;

          .checkbox-wrapper {
            display: flex;
            align-items: center;
            gap: 4px;

          > div {
              width: max-content;

              .label {
                gap: 0 !important;

                > span{
                  margin: 0 !important;
                }
              }
            }
          }

          .column-label {
            font-size: 14px;
            font-weight: 600;
          }

          .bulk-dropdown-wrapper {
            position: relative;
            display: flex;
            align-items: center;
            z-index: 60;

            .bulk-dropdown-trigger {
              background: transparent;
              border: none;
              cursor: pointer;
              border-radius: 5px;
              padding: 4px;
              display: flex;
              align-items: center;
              gap: 4px;
              outline: none;
         
            }

            .bulk-dropdown-menu {
              position: absolute;
              top: 100%;
              left: 0;
              margin-top: 4px;
              background: white;
              border: 1px solid #e9ecef;
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              min-width: 200px;
              z-index: 70;

              .bulk-dropdown-list {
                list-style: none;
                margin: 0;
                padding: 8px 0;

                li {
                  padding: 0;
                  margin: 0;

                  .bulk-dropdown-item {
                    width: 100%;
                    padding: 10px 16px;
                    background: transparent;
                    border: none;
                    text-align: left;
                    cursor: pointer;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    color: var(--primary);
                    transition: background 0.2s;

                    &:hover {
                      background: #f8f9fa;
                    }

                    &.delete {
                      color: #dc3545;
                    }
                  }
                }
              }
            }
          }

          .label {
            gap: 65px;
          }
        }

        label {
          display: block;
          margin: 0;

          span {
            font-size: 14px;
          }
        }
      }
      tr {
        border-bottom: 0;
      }

      td {
        .lead-td-col {
          width: max-content;
          label {
            margin: 0;
            cursor: pointer;
          }

          .text-wrap {
            flex-grow: 1;
          }

      
        }
      }

      .action-list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        li {
          margin: 0;
          position: relative;
          z-index: 1;

          &.active {
            z-index: 3000;
          }

          &.disabled {
            cursor: not-allowed !important;
            button {
              cursor: inherit;
            }
          }

          .btn {
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            cursor: pointer;
            padding: 0;
            border-radius: 5px;
            outline: none;
            box-shadow: none;
          }

          img {
            display: block;
            flex-shrink: 0;
            max-width: 100%;
            height: auto;
            width: 16px;
            height: 20px;

            &.menu {
              width: 5px;
            }
          }
        }

        .dropdown-menu {
          position: absolute;
          top: 100%;
          right: 0;
          width: 170px;
          z-index: 3500;

          .dropdown-list {
            width: 100%;
            list-style: none;
            margin: 0;
            padding: 10px 0;
            border-radius: 5px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            background: var(--white);

            li {
              margin: 0;
              padding: 0;
              &:hover {
                background: linear-gradient(90deg, rgba(39, 131, 236, 0.1) 0%, rgba(30, 220, 227, 0.1) 100%);
              }

              .item-btn {
                position: relative;

                &.loading {
                  cursor: not-allowed;
                  opacity: 0.7;

                  &::before {
                    display: block;
                  }
                }

                &::before {
                  content: '';
                  position: absolute;
                  inset: 0;
                  background: rgba(0, 0, 0, 0.1);
                  display: none;
                }

                &:disabled {
                  cursor: not-allowed;
                  opacity: 0.7;
                }
              }
            }

            .item-btn {
              display: flex;
              align-items: center;
              gap: 10px;
              width: 100%;
              padding: 5px 15px;
              background: transparent;
              color: var(--primary);
              font-size: 13px;
              line-height: 16px;
              text-align: left;
              cursor: pointer;
            }
          }
        }
      }
    }

    tbody {
      position: relative;
      z-index: 1;
    }
    .table-footer {
      left: 322px;
      transition: all 0.350s ease-in-out;
      @media (min-width: 1450px) {
        left: 385px;

      }

      .aside-active & {
        left: 490px;
        @media (min-width: 1450px) {
          left: 590px;
        }
      }
    }

    /* .infinite-scroll-component__outerdiv,
    .infinite-scroll-component {
      height: 100% !important;
      } */
    /* .infinite-scroll-component__outerdiv {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }

    .infinite-scroll-component {
      flex-grow: 1;
    } */

    #leads-table-scrollable {
      display: flex;
      height: calc(100vh - 80px);
      overflow: auto;
    }

    .skeleton-loader-row {
      display: flex;
      justify-content: space-around;
      gap: 10px;
    }
  }
`;

export const LocationFilterTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;

  .location-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    background: #eef4ff;
    border-radius: 16px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #262e3d;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;
      color: #7f8594;
      font-size: 16px;
      line-height: 1;

      &:hover {
        color: #262e3d;
      }
    }
  }
`;

export const StyledFiltersList = styled.ul`
      list-style: none;
      margin: 0;
      padding: 0;
      /* position: relative;

   &::before {
     content: "";
     position: absolute;
     inset: 0;
     z-index: -1;
     border-radius: inherit;
 
     background: linear-gradient(
       90deg,
       #367eee 0%,
       #b74bff 50.96%,
       #feb508 100%
     );
 
     filter: blur(3px);
     opacity: 0.09;
   } */


      li {
        position: relative;
        &.active {
          .opener {
            .icon {
              color: #1c1c1c;
              transform: scaleY(-1);
            }
          }
        }

        .opener {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          width: 100%;
          text-align: left;
          font-size: 14px;
          line-height: 18px;
          font-weight: 500;
          color: #262e3d;
          text-transform: capitalize;
          padding: 20px 20px;

          .icon {
            display: block;
            font-size: 20px;
            color: #d8dae0;
          }
        }

        .slide {
          font-size: 12px;
          line-height: 16px;
          font-weight: 500;
          color: #7f8594;
          overflow: hidden;
          border-top: 1px solid #dedede;
          transition: all 0.3s ease;
          background: #fdfdfd;
        }

        &:not(.active) .slide {
          border-top-color: transparent;
        }

        .list {
          list-style: none;
          margin: 0;
          padding: 20px;

          li {
            padding: 3px 0;
          }

          .custom-radio {
            display: flex;
            align-items: center;
            gap: 10px;
            margin: 0 0 8px;

            input {
              width: 18px;
              height: 18px;
            }
          }

          .specific-date {
            &.active {
              .radio-opener {
                &::before {
                  border-color: #317bff;
                }
                &::after {
                  display: block;
                }
              }
            }

            .radio-opener {
              position: relative;
              padding: 2px 0 0 28px;

              &::before,
              &::after {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                content: '';
                width: 18px;
                height: 18px;
                border: 1px solid rgba(0, 0, 0, 0.5);
                border-radius: 50px;
                background: var(--white);
              }
              &::after {
                display: none;
                top: 4px;
                left: 4px;
                width: 10px;
                height: 10px;
                border: 0;
                background: #317bff;
              }
            }
            .input-slide {
              position: relative;
              padding: 10px 0 0 25px;

              .date {
                width: 100%;
                height: 40px;
                padding: 10px;
                border-radius: 8px;
                border: 1px solid #dedede;
              }
            }
          }

          .checkbox-list {
            span {
              font-size: 13px;
              color: #7f8594;
            }
          }
        }

        .item-list {
          list-style: none;
          margin: 0;
          padding: 10px 0 0;

          li {
            margin: 0;
            padding: 4px 0;
          }

          .item {
            display: flex;
            align-items: center;
            gap: 10px;
            position: relative;
            padding: 10px 33px 10px 10px;
            border-radius: 10px;
            background: rgba(39, 131, 236, 0.05);

            .btn-close {
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);
              font-size: 20px;
              color: rgba(49, 123, 255, 0.75);
              cursor: pointer;
            }

            .img-wrap {
              width: 22px;
              height: 22px;
              border-radius: 50px;
              overflow: hidden;
            }
            .name {
              font-size: 13px;
              line-height: 16px;
              color: var(--black);
            }
          }
        }
    }
`

export const StyledSingleLeads = styled.div`
  position: relative;

  .filter-wrap {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    margin-bottom: 15px;
    padding: 15px 15px 0;
    border-top: 1px solid #e6e7ec;
    &.single-lead-filter {
      border-top: 0;
    }

    @media (min-width: 430px) {
      flex-direction: row;
    }
    @media (min-width: 1440px) {
      margin-bottom: 15px;
      padding: 20px 20px 0;
    }

    .input-search {
      color: #1c1c1c;
      &::placeholder {
        color: #1c1c1c;
      }
    }

    .inner-filter {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .filter-box {
      position: relative;

      .btn-filter {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: #fafafa;
        border: none;
        cursor: pointer;

        .icon {
          cursor: pointer;
          color: var(--blue);
        }
      }
    }

    .form-wrap {
      display: flex;
      align-items: baseline;
      gap: 10px;
      @media (max-width: 575px) {
        margin-bottom: 20px;
      }
      span {
        color: #313131;
      }
    }
    .selectwrap {
      width: 100%;

      @media (min-width: 576px) {
        width: 180px;
        flex-shrink: 0;
      }

      > div {
        width: 180px;
      }
      .react-select__control {
        border: 0;
        background: #fcfcfc;
      }
    }
  }

.filters-holder{
  width: 0;
  z-index: 1;
  border-right: 1px solid #e6e7ec;
  height:calc(100vh - 209px) ;
  transition: all 0.3s ease;
  overflow: auto;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  left: -300px;
  /* transform: translateX(-101%); */
  
  &.active {
    width: 300px;
    /* transform: translateX(0); */
    left:0 ;
  }

  &::-webkit-scrollbar {
    width: 0;
}
}
  table {
    thead {
      border-bottom: 1px solid #e6e7ec;
      background: rgba(253, 253, 253, 0.5);
      position: relative;
      z-index: 50;

      .th-label-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;

        .checkbox-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;

          > div {
            width: max-content;

            .label {
              gap: 0 !important;

              > span{
                margin: 0 !important;
              }
            }
          }
        }

        .column-label {
          font-size: 14px;
          font-weight: 600;
        }

        .bulk-dropdown-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          z-index: 60;

          .bulk-dropdown-trigger {
            background: transparent;
            border: none;
            cursor: pointer;
            border-radius: 5px;
            padding: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
            outline: none;
          }

          .bulk-dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            margin-top: 4px;
            background: white;
            border: 1px solid #e9ecef;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            min-width: 200px;
            z-index: 70;

            .bulk-dropdown-list {
              list-style: none;
              margin: 0;
              padding: 8px 0;

              li {
                padding: 0;
                margin: 0;

                .bulk-dropdown-item {
                  width: 100%;
                  padding: 10px 16px;
                  background: transparent;
                  border: none;
                  text-align: left;
                  cursor: pointer;
                  font-size: 14px;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  color: var(--primary);
                  transition: background 0.2s;

                  &:hover {
                    background: #f8f9fa;
                  }

                  &.delete {
                    color: #dc3545;
                  }
                }
              }
            }
          }
        }

        .label {
          gap: 65px;
        }
      }

      label {
        display: block;
        margin: 0;

        span {
          font-size: 14px;
        }
      }
    }

    td {
      .lead-td-col {
        
        width: max-content;
        label {
          margin: 0;
          cursor: pointer;
        }

        .text-wrap {
          flex-grow: 1;
        }

      }
    }

    tbody {
      position: relative;
      z-index: 1;
    }
  }

  .table-area {
    flex-grow: 1;

    
    .inner-wrap {
      transition: all 0.350s ease-in-out;
      height: calc(100vh - 145px);
    }

    &.single-list-leads-table{
      display: flex;

      .inner-wrap {
      height: calc(100vh - 210px);
      transition: all 0.350s ease-in-out;


.trial-banner-visible & {
    height: calc(100dvh - 250px);
}
      }
    }

    table {
      thead {
        border-bottom: 1px solid #e6e7ec;
        background: rgba(253, 253, 253, 0.5);
      }
      tr {
        border-bottom: 0;
      }

      th:last-child {
        width: 300px;
        word-break: break-all;
      }

      th,
      td {
        text-align: center;
      }

      .sortable-header {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        cursor: pointer;

        .icon {
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
  }

  .quick-action-box {
    position: relative;

    .quick-list {
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 10px 13px;
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 4px;
      font-size: 14px;
      line-height: 17px;
      color: #575757;
      border-radius: 8px;
      border: 1px solid rgba(222, 222, 222, 0.5);
      background: var(--white);
      box-shadow: 0px 12px 20px 0px rgba(0, 0, 0, 0.05);
      z-index: 9999;

      li {
        padding: 4px 0;

        &:hover {
          color: var(--black);
        }

        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;

          &:hover {
            color: #575757;
          }

          span {
            cursor: not-allowed;
            pointer-events: none;
          }

          .disabled-tooltip-wrapper {
            position: relative;
            display: inline-block;
            cursor: not-allowed;

            &:hover .disabled-tooltip {
              opacity: 1;
              visibility: visible;
            }

            .disabled-tooltip {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: calc(100% + 8px);
              background: #fff;
              border: 1px solid #c4c3c3;
              border-radius: 8px;
              padding: 8px 12px;
              font-size: 13px;
              line-height: 16px;
              color: #6c6a6a;
              white-space: nowrap;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              opacity: 0;
              visibility: hidden;
              transition: all 0.2s ease;
              z-index: 1000;
              width: 280px;
              white-space: normal;
              text-align: center;

              &::before {
                content: '';
                position: absolute;
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%);
                border: 6px solid transparent;
                border-bottom-color: #6c6a6a;
              }
            }
          }
        }

        span {
          cursor: pointer;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          gap: 5px;

          &.delete {
            color: #ff7d7f;
          }
        }
      }
    }
  }

  .btn-quick {
      min-width: 185px;
      justify-content: space-between;
      padding: 7px 12px;

      &.active {
        .icon-arrow {
          transform: scale(-1);
        }
      }

      .icon {
        color: #2eca8b;
      }

      .icon-arrow {
        font-size: 24px;
        color: #7f8594;
        transition: all ease-in-out 0.3s;
      }
    }

  .action-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    li {
      margin: 0;
      position: relative;
      z-index: 1;

      &.active {
        z-index: 3000;
      }

      &.disabled {
        cursor: not-allowed !important;
        button {
          cursor: inherit;
        }
      }

      .btn {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        cursor: pointer;
        padding: 0;
        border-radius: 5px;
        outline: none;
        box-shadow: none;
        background: #f1f1f1;
      }

      img {
        display: block;
        flex-shrink: 0;
        max-width: 100%;
        height: auto;
        width: 16px;
        height: 20px;

        &.menu {
          width: 5px;
        }
      }
    }

    .dropdown-menu {
      position: absolute;
      top: 100%;
      right: 0;
      width: 170px;
      z-index: 3500;

      .dropdown-list {
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 10px 0;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        background: var(--white);

        li {
          margin: 0;
          padding: 0;
          &:hover {
            background: linear-gradient(90deg, rgba(39, 131, 236, 0.1) 0%, rgba(30, 220, 227, 0.1) 100%);
          }

          .item-btn {
            position: relative;

            &.loading {
              cursor: not-allowed;
              opacity: 0.7;

              &::before {
                display: block;
              }
            }

            &::before {
              content: '';
              position: absolute;
              inset: 0;
              background: rgba(0, 0, 0, 0.1);
              display: none;
            }

            &:disabled {
              cursor: not-allowed;
              opacity: 0.7;
            }
          }
        }

        .item-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 5px 15px;
          background: transparent;
          color: var(--primary);
          font-size: 13px;
          line-height: 16px;
          text-align: left;
          cursor: pointer;
        }
      }
    }
  }
`;

export const MappingContacts = styled.div`
  position: relative;
`;

export const StyledAddToModalContent = styled.div`
  .button-group {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .preview-loading {
    padding: 20px 0;
    text-align: center;
    color: #666;
    font-size: 14px;
  }

  .preview-container {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
    border: 1px solid #e9ecef;
  }

  .preview-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .preview-stat {
    text-align: center;

    .stat-label {
      font-size: 12px;
      color: #6c757d;
      margin-bottom: 4px;
    }

    .stat-value {
      font-size: 24px;
      font-weight: 600;

      &.total {
        color: #495057;
      }

      &.duplicate {
        color: #dc3545;
      }

      &.unique {
        color: #28a745;
      }
    }
  }
`;

export const StyledResyncModalContent = styled.div`
  .message-container {
    background: #f8f9fa;
    border-left: 4px solid #317bff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 24px;
  }

  .message-title {
    font-size: 16px;
    font-weight: 600;
    color: #262e3d;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .message-text {
    font-size: 14px;
    line-height: 1.6;
    color: #495057;
    margin: 0;

    strong {
      color: #317bff;
      font-weight: 600;
    }
  }

  .button-group {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
`;
